import { MeshUtils3 } from '@seddi/geometry';
import { TriMeshGrid2 } from '../garmentGeometry/triMeshGrid2';

/**
 * Piece extension.
 */
export class PieceExt {
  private _grid?: TriMeshGrid2;
  private _gridIndices?: Uint32Array;
  private _gridPositions?: Float32Array;

  private _normals?: Float32Array;
  private _normalsIndices?: Uint32Array;
  private _normalsPositions?: Float32Array;

  get grid(): TriMeshGrid2 {
    return this._grid!;
  }

  get normals(): Float32Array {
    return this._normals!;
  }

  clear() {
    this._grid = undefined;
    this._gridIndices = undefined;
    this._gridPositions = undefined;
    this._normals = undefined;
    this._normalsIndices = undefined;
    this._normalsPositions = undefined;
  }

  updateGrid(indices: Uint32Array, positions: Float32Array, cellSize: number) {
    // Discard update when props are the same
    if (this._gridIndices === indices && this._gridPositions === positions) {
      return;
    }
    // Recreate grid
    this._grid = new TriMeshGrid2();
    this._grid.init(indices, positions, cellSize);
    this._gridIndices = indices;
    this._gridPositions = positions;
  }

  updateNormals(indices: Uint32Array, positions: Float32Array) {
    // Discard update when props are the same
    if (this._normalsIndices === indices && this._normalsPositions === positions) {
      return;
    }
    // Recreate normals
    this._normals = MeshUtils3.computeNormals(indices, positions);
    this._normalsIndices = indices;
    this._normalsPositions = positions;
  }
}
